var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-popup",attrs:{"id":_vm.id}},[_c('div',{staticClass:"modal-popup-content"},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif")}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('loadingPopupMessage'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }